import { getModuleColor } from "../services/previewService";

// Consistent module number → name mapping (same across all programs)
const MODULE_NUMBER_TO_NAME: Record<string, string> = {
  module1: "Reading",
  module2: "Listening",
  module3: "Speaking",
  module4: "Writing",
  module5: "Grammar",
  module6: "Vocabulary",
  module7: "Review",
};

/**
 * Extract a readable module name from a moduleId.
 * e.g. "eap_yellow_week1_module1" → "Reading"
 *      "eap_green_week3_module5" → "Grammar"
 */
export const getModuleName = (moduleId: string): string => {
  const match = moduleId.match(/(module\d+)/);
  if (match) {
    return MODULE_NUMBER_TO_NAME[match[1]] || match[1];
  }
  return moduleId;
};

/**
 * Extract week number from moduleId.
 * e.g. "eap_yellow_week3_module1" → 3
 */
export const getWeekFromModuleId = (moduleId: string): number => {
  const match = moduleId.match(/week(\d+)/);
  return match ? parseInt(match[1]) : 0;
};

/**
 * Format moduleId for display: "Week 3 — Reading"
 */
export const formatModuleLabel = (moduleId: string): string => {
  const week = getWeekFromModuleId(moduleId);
  const name = getModuleName(moduleId);
  return week > 0 ? `Week ${week} — ${name}` : name;
};

/**
 * Get color for a moduleId (delegates to previewService)
 */
export const getModuleColorFromId = (moduleId: string): string => {
  const name = getModuleName(moduleId).toLowerCase();
  return getModuleColor(name);
};
